import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  clientCode = localStorage.getItem("clientCode");
  constructor(private http: HttpClient) { }

  askDynamicQuestion(request: any): Observable<any> {
    let headers = new HttpHeaders({ 'X-Tenant-ID': this.clientCode });
    return this.http.post<string>(environment.baseUrlAiService + 'ask_agent', request, { headers });
  }

  exportFile(data): Observable<Blob> {
    const headers = new HttpHeaders({ 'Accept': 'application/octet-stream', 'X-Tenant-ID': this.clientCode });
    return this.http.post(environment.baseUrlAiService + 'download', data, {
      headers,
      responseType: 'blob'
    });
  }
  getAllUserChats(request: any): Observable<any> {
    let headers = new HttpHeaders({ 'X-Tenant-ID': this.clientCode });
    return this.http.post<string>(environment.baseUrlAiService + 'get_user_chats', request, { headers });
  }

  getChatHistory(request: any): Observable<any> {
    let headers = new HttpHeaders({ 'X-Tenant-ID': this.clientCode });
    return this.http.post<string>(environment.baseUrlAiService + 'get_user_messages', request, { headers });
  }

  startNewChat(request: any): Observable<any> {
    let headers = new HttpHeaders({ 'X-Tenant-ID': this.clientCode });
    return this.http.post<string>(environment.baseUrlAiService + 'start_chat', request, { headers });
  }

  getLiveData(chatKey: any): Observable<any> {
    let headers = new HttpHeaders({ 'X-Tenant-ID': this.clientCode });
    return this.http.get<string>(environment.baseUrl + 'api/chat/get-live-response' + '?chatKey=' + chatKey, { headers });
  }
}